import * as React from 'react';
import { Translate } from '../../../../shared/LanguageService';
import { IPhotographerInvoice } from '../photographer/SinglePhotographerInvoiceTypes';
import { Row, Col } from 'react-bootstrap';

interface IProps {
    invoice: IPhotographerInvoice;
    key: number;
    view: (invoice: IPhotographerInvoice) => void;
}

const ExcludedInvoiceListRow = (props: IProps) => {
    return (
        <Row>
            <Col sm={12} md={6}>
                <div>{props.invoice.photographerName}</div>
            </Col>
            <Col sm={12} md={6}>
                {props.invoice.id > 0 && (
                    <a onClick={() => props.view(props.invoice)}>{props.invoice.name}</a>
                )}
                {props.invoice.id === 0 && <div>{props.invoice.name}</div>}
            </Col>
        </Row>
    );
};

export default ExcludedInvoiceListRow;
